// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlApi: 'https://api-pxy.denariotest.com.co/api/',
  urlApiL: 'http://localhost:4370/api/',
  suclkect: 'http://localhost:4370',
  suclkectprod: 'https://api-pxy.denario.com.co',
  Authorization: 'AutDenarioCoorp2021',
  authorizacionConveniosApp: 'AutDenarioApp2021',
  LOCAL_STORAGE: 'DenarioCoorpStorage'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.